module.exports = __webpack_public_path__ + "static/media/website-09.9ebe0c9f.png";